export default __webpack_public_path__ + "ec037bd364698a7608814972e0b0015f.png";